export default function TestPage() {
  return (
    <div style={{ padding: '20px', background: 'lightblue' }}>
      <h1>테스트 페이지</h1>
      <p>이 페이지가 보인다면 React가 정상적으로 작동하고 있습니다.</p>
      <p>현재 경로: {window.location.pathname}</p>
    </div>
  )
}